import React from 'react';

export function youtubeEmbedUrl(href) {
  try {
    const url = new URL(href);
    if (!['https:', 'http:'].includes(url.protocol)) return null;
    const host = url.hostname.toLowerCase();
    let id;
    if (host === 'youtu.be') {
      id = url.pathname.slice(1);
    } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(host)) {
      id = url.pathname === '/watch'
        ? url.searchParams.get('v')
        : url.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)\/?$/)?.[1];
    }
    if (!/^[\w-]{11}$/.test(id || '')) return null;
    const embed = new URL(`https://www.youtube.com/embed/${id}`);
    const time = url.searchParams.get('start') || url.searchParams.get('t');
    if (time) {
      const match = time.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
      const seconds = /^\d+$/.test(time) ? Number(time)
        : match ? Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0) : 0;
      if (Number.isSafeInteger(seconds) && seconds > 0) embed.searchParams.set('start', seconds);
    }
    return embed.toString();
  } catch {
    return null;
  }
}

export default function YouTubeParagraph({ node, children, ...props }) {
  const content = node?.children?.filter((child) => child.type !== 'text' || child.value.trim());
  const link = content?.length === 1 && content[0].tagName === 'a' ? content[0] : null;
  const src = link && youtubeEmbedUrl(link.properties?.href);
  if (!src) return <p {...props}>{children}</p>;

  return (
    <div {...props} className="journal-youtube">
      <iframe
        src={src}
        title="YouTube 動画"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
      />
      <a href={link.properties.href} target="_blank" rel="noopener noreferrer">YouTube で見る</a>
    </div>
  );
}
